import { create } from "zustand";
import dayjs, { Dayjs } from 'dayjs';
import { RouteService, SourceReferenceSystem } from "../services/RuteplanAPI";

export const RouteTypes = [
    "best",
    "tourist",
    //"bike",
    "bruksklasseNormalTransport",
    "bruksklasseSpesialTransport",
    "bruksklasseTommerTransport",
    "bruksklasseModulvognTog",
    "bruksklasse12100",
    "bruksklasse1265"
];
export type RouteType = typeof RouteTypes[number];

export const BruksklasserNormalTransport = [
    "Bk_6_28",
    "Bk_8_32",
    "Bk_T8_40",
    "Bk_10_42",
    "Bk_T8_50",
    "Bk_10_50",    
];

type bruksklasseNormalTransportArguments = Parameters<typeof RouteService.routeBruksklasseNormalTransport>
export type BruksklasseNormalTransport = bruksklasseNormalTransportArguments[0]["bruksklasse"] | undefined;

export const BruksklasserSpesialTransport = [
    "Bk_6_28",
    "Bk_8_32",
    "Bk_T8_40",
    "Bk_10_42",
    "Bk_T8_50",
    "Bk_10_50",   
];
type bruksklasseSpesialTransportArguments = Parameters<typeof RouteService.routeBruksklasseSpesialTransport>
export type BruksklasseSpesialTransport = bruksklasseSpesialTransportArguments[0]["bruksklasse"] | undefined;

export const AvailableVegrupper = [
    "A",
    "B",
    "Ikke"
]
export type Veggruppe = bruksklasseSpesialTransportArguments[0]["veggruppe"];

export const BruksklasserTommerTransport = [
    "Bk_6_28",
    "Bk_8_32",
    "Bk_T8_40",
    "Bk_10_42",
    "Bk_T8_50",
    "Bk_10_50",
    "Bk_10_56",
    "Bk_10_60"
];
type bruksklasseTommerTransportArguments = Parameters<typeof RouteService.routeBruksklasseTommerTransport>
export type BruksklasseTommerTransport = bruksklasseTommerTransportArguments[0]["bruksklasse"] | undefined;

export const BruksklasserModulvogntog = [
    "Bk_6_28",
    "Bk_8_32",
    "Bk_T8_40",
    "Bk_10_42",
    "Bk_T8_50",
    "Bk_10_50",
    "Bk_10_56",
    "Bk_10_60"
];
type bruksklassModulvogntogArguments = Parameters<typeof RouteService.routeBruksklasseModulvognTog>
export type BruksklasseModulvogntog = bruksklassModulvogntogArguments[0]["bruksklasse"];

export interface RouteSettings {
    routeType: RouteType;
    length: number | null;
    weight: number | null;
    height: number | null;    
    avoidSituationIds: string | null;
    avoidFeatureInstanceIds: string | null;
    avoidTrafficMessageTypes: string | null;
    avoidRoadFeatureTypes: Array<string> | null;
    startTime: Dayjs;
    bruksklasseNormalTransport: BruksklasseNormalTransport | undefined;
    bruksklasseSpesialTransport: BruksklasseSpesialTransport | undefined;
    includeVeggruppeIkke: boolean;
    veggruppe: Veggruppe;
    bruksklasseTommerTransport: BruksklasseTommerTransport | undefined;
    bruksklasseModulvogntog: BruksklasseModulvogntog | undefined;
    erLinkSemiTrailer: boolean;
    includeObstructedRoutes: boolean;
    medSporingskrav: boolean;
    outputSrs: SourceReferenceSystem;
    inputSrs: SourceReferenceSystem;
}

const defaultRouteSettings: RouteSettings = {
    routeType: "best",    
    length: null,
    weight: null,
    height: null,
    avoidSituationIds: null,
    avoidFeatureInstanceIds: null,
    avoidTrafficMessageTypes: null,
    avoidRoadFeatureTypes: null,
    startTime: dayjs( new Date()),
    bruksklasseNormalTransport: "Bk_6_28",
    bruksklasseSpesialTransport: "Bk_6_28",
    includeVeggruppeIkke: false,
    veggruppe: "A",
    bruksklasseTommerTransport: "Bk_6_28",
    bruksklasseModulvogntog: "Bk_6_28",
    erLinkSemiTrailer: false,
    medSporingskrav: false,
    includeObstructedRoutes: false,
    outputSrs: SourceReferenceSystem.EPSG_4326,
    inputSrs: SourceReferenceSystem.EPSG_4326
}

export interface IRouteSettingsActions {
    setRouteSettings: (routeSettings: RouteSettings) => void;
}   

export interface IRouteSettingsState {
    routeSettings: RouteSettings;
    actions: IRouteSettingsActions;
}

const useRouteSettingsStore = create<IRouteSettingsState>( (set) => ({
    routeSettings: defaultRouteSettings,
    actions: {
        setRouteSettings: (routeSettings: RouteSettings) => {
            set({
                routeSettings: routeSettings
            });
        }
    }
}));

export const useRouteSettings = () => useRouteSettingsStore((state) => state.routeSettings);
export const useRouteSettingsActions = () => useRouteSettingsStore((state) => state.actions);